export default __webpack_public_path__ + "static/thomas-7b107311192bd938f459643acbfa1c1a.png";